// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (C) 2026 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

.error-page-shell {
  background-color: #F4EFE7;
  display: flex;
  flex-direction: column;
}

.error-page-layout {
  flex: 1;
  box-sizing: border-box;
  padding: 86px clamp(16px, 12vw, 240px);
  width: 100%;
}

.error-page-card-layout-item {
  max-width: 568px;
  min-width: 0;
  width: 100%;
}

.error-page-content-layout {
  align-items: flex-start;
  text-align: left;
  width: 100%;
}

.error-page-card {
  background-color: #fff;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 8px 0;
  max-width: 568px;
  width: 100%;
}

.error-page-section-header {
  padding: 8px 16px;
}

.error-page-card-content {
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  padding: 32px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.error-heading {
  margin: 0;
}

.error-description {
  max-width: 54ch;
  line-height: 1.5;
}

.error-message-line {
  display: block;
}

.error-description-line {
  margin-top: 16px;
}

.helpdesk-cta {
  min-width: auto;
  width: fit-content;
}

.error-page-actions {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding-top: 16px;
  width: 100%;
}

.error-code {
  margin: 0;
}

@media (max-width: 640px) {
  .error-page-layout {
    padding: 48px 24px;
  }
}

@media (max-width: 480px) {
  .error-page-layout {
    padding: 32px 16px;
  }

  .error-page-actions {
    align-items: flex-end;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Error/ErrorPage.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,sBAAsB;EACtB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF","sourcesContent":["/*\n * Copyright (C) 2026 JPMorgan Chase & Company\n * All rights reserved.\n *\n * Redistribution and use in source and binary forms, with or without\n * modification, is not permitted.\n */\n\n.error-page-shell {\n  background-color: #F4EFE7;\n  display: flex;\n  flex-direction: column;\n}\n\n.error-page-layout {\n  flex: 1;\n  box-sizing: border-box;\n  padding: 86px clamp(16px, 12vw, 240px);\n  width: 100%;\n}\n\n.error-page-card-layout-item {\n  max-width: 568px;\n  min-width: 0;\n  width: 100%;\n}\n\n.error-page-content-layout {\n  align-items: flex-start;\n  text-align: left;\n  width: 100%;\n}\n\n.error-page-card {\n  background-color: #fff;\n  border-radius: 16px;\n  box-sizing: border-box;\n  padding: 8px 0;\n  max-width: 568px;\n  width: 100%;\n}\n\n.error-page-section-header {\n  padding: 8px 16px;\n}\n\n.error-page-card-content {\n  background-color: #fff;\n  border-radius: 16px;\n  border: 1px solid #d8d8d8;\n  box-sizing: border-box;\n  padding: 32px 16px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.error-heading {\n  margin: 0;\n}\n\n.error-description {\n  max-width: 54ch;\n  line-height: 1.5;\n}\n\n.error-message-line {\n  display: block;\n}\n\n.error-description-line {\n  margin-top: 16px;\n}\n\n.helpdesk-cta {\n  min-width: auto;\n  width: fit-content;\n}\n\n.error-page-actions {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding-top: 16px;\n  width: 100%;\n}\n\n.error-code {\n  margin: 0;\n}\n\n@media (max-width: 640px) {\n  .error-page-layout {\n    padding: 48px 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .error-page-layout {\n    padding: 32px 16px;\n  }\n\n  .error-page-actions {\n    align-items: flex-end;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
